if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.source = document.getElementById(this.dataset.source);
        this.button = this.querySelector('.sticky-atc__button');
        if (!this.source || !this.button) return;

        this.footer = document.querySelector('.shopify-section-group-footer-group');
        this.onScroll = this.onScroll.bind(this);

        this.syncButton();
        this.mutationObserver = new MutationObserver(this.syncButton.bind(this));
        this.mutationObserver.observe(this.source, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        });

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      // La barra aparece cuando el boton original salio de la vista y se
      // guarda al final de la pagina para no tapar el cierre del pie.
      update() {
        const showBar = this.isOutOfView(this.source) && !this.isPageEndReached();
        this.classList.toggle('sticky-atc--visible', showBar);

        // Deja el alto publicado para que los botones flotantes de las apps
        // (WhatsApp) puedan subirse por encima de la barra.
        document.body.classList.toggle('sticky-atc-active', showBar);
        document.documentElement.style.setProperty(
          '--sticky-atc-height',
          showBar ? `${Math.round(this.offsetHeight)}px` : '0px'
        );
      }

      isPageEndReached() {
        if (!this.footer) return false;

        return this.footer.getBoundingClientRect().bottom <= window.innerHeight;
      }

      isOutOfView(element) {
        if (!element) return true;

        const rect = element.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return true;

        return rect.bottom <= 0 || rect.top >= window.innerHeight;
      }

      syncButton() {
        const label = this.source.querySelector('span');
        const target = this.button.querySelector('span');
        if (label && target && target.textContent !== label.textContent) {
          target.textContent = label.textContent;
        }

        this.button.disabled = this.source.hasAttribute('disabled');
        this.button.classList.toggle('loading', this.source.classList.contains('loading'));
      }
    }
  );
}
